import { merge } from 'lodash';
import { D as DEFAULT_RICOS_COMPONENT_DATA } from './helpers-d59c72d9.js';
import 'wix-rich-content-common/libs/imageUtils';

const createPollData = (pluginData = {}) => {
  return merge({}, DEFAULT_RICOS_COMPONENT_DATA, pluginData);
};

export { createPollData };
//# sourceMappingURL=createPollData.js.map
